import { BusinessTypes, CurrencyTypes, CustomerCount, ImageTypes, MeasureTypes, MenuCategoryTypes, MenuItemTypes, OrderTypes, TimeUnitTypes } from "./componentTypes"
import { OrderStatus } from "./formValue-interfaces"

export interface IErrorResponse {
    error: number,
    result: any
};

export interface IUser {
    id: number,
    username: string,
    email: string,
    first_name: string,
    last_name: string
};

export interface ILoginResponse {
    user_detail: {
        id: number,
        user: IUser,
        phone_number: string,
        user_role: string
    },
    access: string,
    refresh: string
};

export enum UserRoles {
    MANAGER = 'manager',
    WAITER = 'waiter'
}

export interface IGetMe {
    id: number,
    phone_number: string,
    user_role: UserRoles,
    user: IUser
};

export interface IUploadImageResponse {
    id: number,
    src: string,
    image_type: ImageTypes
}

export interface IContacts {
    phone_numbers?: string[],
    facebook?: string | null,
    twitter?: string | null,
    instagram?: string | null,
    telegram?: string | null,
    whatsapp?: string | null,
    viber?: string | null
}

export interface IBusinessProfile {
    address: string,
    free_days: number[],
    full_week: boolean,
    start_time: string | null,
    end_time: string | null,
    is_24: boolean,
    gallery?: string[]
}

export interface IDeliveryCity {
    id?: number;
    city: string;
    cost: number;
    regions?: IDeliveryRegion[]; // For Yerevan, can have regions/districts
}

export interface IDeliveryRegion {
    id?: number;
    name: string;
    cost: number;
}

export interface IServices {
    delivery: {
        min_cost: null | number, // Keep for backward compatibility
        is_active: boolean,
        cities?: IDeliveryCity[]; // Cities with delivery and their costs
    },
    pre_order: boolean,
    reserve: boolean;
}


export interface ICompanyResponse {
    id: number,
    name: string,
    country: string,
    city: string,
    customer_count: CustomerCount,
    type: BusinessTypes,
    logo: string,
    styles:null | string,
    qr_company: string,
    qr_menu: string,
    menu_list: IMenuListItem[],
    created_at: string,
    expired_at: string,
    demo_version: boolean,
    demo_expired_at:string,
    template_id: number,
    autor_id?: number,
    cost_currency?: CurrencyTypes,
    service_fee?: string,
    pos_terminal?: boolean | null,
    visitors_count?: number,
    business_profile?: IBusinessProfile,
    contacts: IContacts | null,
    services: IServices | null
};

export type GetMyCompaniesResponse = ICompanyResponse[] | [];

export interface ICategory {
    id: number,
    default_image: 'string',
    upload_image: null | string,
    name_en: string,
    name_ru: string,
    name_hy: string
    menu_type: MenuCategoryTypes,
    is_author: boolean
}



export interface IMenuListItem {
    category: ICategory
}

export interface IMenuItemOptionResponce {
    option_id: number,
    measure_type: MeasureTypes,
    measure_value?: string,
    price: string,
    package_cost?: string,
    is_active: boolean,
}

export interface IMenuItemResponce {
    id: number,
    category_id: 2,
    company_id: 1,
    name_en: string,
    name_ru: string,
    name_hy: string,
    description_en: string,
    description_ru: string,
    description_hy: string,
    is_active: boolean,
    image: string,
    cooking_time: string,
    cooking_time_unit: TimeUnitTypes,
    option: IMenuItemOptionResponce[],
}

export type MenuItems = IMenuItemResponce[];

export interface IMenuListItem {
    category: ICategory,
    items: MenuItems,
    order_list: [] | number[]
};

export type MenuListResponce = [] | IMenuListItem[];

export interface ContactLinkResult {
    href: string;
    fallback: string;
    open: () => void;
}

export interface IVerifyCodeResponse {
    message: string,
    user_uuid: string
}

export interface IOrderResponse {
    created_at: string | Date,
    data: string,
    id: string,
    order_parameters: string,
    order_type: OrderTypes,
    status: OrderStatus
}

export interface IMyOrdersResponse {
    count: number,
    next: string | null,
    previous: boolean | null,
    results: IOrderResponse[]
}

export interface ICompanyCurrentOrdersResponce {
    new_orders: IOrderResponse[],
    pending_orders: IOrderResponse[],
    in_preparation_orders: IOrderResponse[],
    out_for_delivery_orders: IOrderResponse[],
    accepted_orders: IOrderResponse[],
    ready_for_pickup_orders: IOrderResponse[],
}

export interface IResendSmsResponse {
    sms_code: string
}